import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LocalizableComponent } from '../components/localizable/localizable.component';

@Component({
    selector: 'ups-system-message',
    templateUrl: './system-message.component.html',
    styleUrls: ['./system-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SystemMessageComponent extends LocalizableComponent {

  showMessage: boolean = true;

  constructor() {
    super();
  }

  closeMessage() {
    this.showMessage = false;
  }

}
